import Swal from "sweetalert2";
import faradayApi from "../../api/faradayApi";

export const createDividend = async (formValues, succesMsg, errorMsg, navigate) => {
    try {
        const { data } = await faradayApi.post('/dividends', formValues);

        if (data.ok === true) {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: succesMsg,
                icon: "success",
            });
            navigate(-1);
            return true;
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: data.msg || errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            });
            return false;
        }
    } catch (error) {
        console.log(error);
        const errorText = error.response?.data?.msg || error.message || error;
        Swal.fire({
            confirmButtonColor: '#001B60',
            text: errorText,
            icon: "error",
            iconColor: '#FF7765'
        });
        return false;
    }
}

export const deleteDividend = async (e, succesMsg, errorMsg, cancelButton, confirmButton, deleteConfirm) => {
    const startupName = e.row.startup?.name || e.row.startup || "";
    const { value } = await Swal.fire({
        text: `${deleteConfirm} (${startupName})`,
        showCancelButton: true,
        confirmButtonColor: '#001B60',
        cancelButtonText: cancelButton,
        confirmButtonText: confirmButton,
        reverseButtons: true
    });
    if (value) {
        return await onConfirm(e.row.id, succesMsg, errorMsg, startupName);
    }
    return false;
}

const onConfirm = async (id, succesMsg, errorMsg, startup) => {
    try {
        const { data } = await faradayApi.delete('/dividends', { data: { id } });
        if (data.ok === true || (data.data !== 0 && !data.error)) {
            await Swal.fire({
                confirmButtonColor: '#001B60',
                text: `${startup} ${succesMsg}`,
                icon: "success",
            });
            return true;
        } else {
            await Swal.fire({
                confirmButtonColor: '#001B60',
                text: data.msg || errorMsg,
                icon: "error",
            });
            return false;
        }
    } catch (error) {
        console.error(error);
        const errorText = error.response?.data?.msg || error.message || error;
        await Swal.fire({
            confirmButtonColor: '#001B60',
            text: errorText,
            icon: "error",
        });
        return false;
    }
}

